import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { APIV2_URL } from './constants';

interface Payload {
  billingCountry?: string;
  paymentMethodId?: number | null;
  paymentMethodReference?: string;
  paymentType: string;
  signature?: string;
  stripeToken?: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload) =>
    makeCall<Conversation>(
      'PUT',
      `${APIV2_URL}/conversation/${conversationId}/booking-request`,
      { data },
    );
